const Embed = {
	init() {
		const containers = document.querySelectorAll('.embeds');

		if (containers.length > 0) {
			Array.prototype.forEach.call(containers, item => {
				item.querySelector('.embeds__iframe iframe')
					.setAttribute(
						'src',
						this.evaluate(item.querySelector('.embeds__iframe iframe').dataset.url
						)
					)
			})
		}
	},

	evaluate(url) {
		const youtubeRegex = /(http:|https:)?\/\/(www\.)?(youtube.com|youtu.be)\/(watch)?(\?v=)?(\S+)?/
		const youtubeMobile = /(http:|https:)?\/\/(m\.)?(youtube.com|youtu.be)\/(watch)?(\?v=)?(\S+)?/
		const youtubePlaylist = /(http:|https:)?\/\/(?:www\.)?youtube\.com\/watch\?(?:&.*)*((?:v=([a-zA-Z0-9_\-]{11})(?:&.*)*&list=([a-zA-Z0-9_\-]{18}))|(?:list=([a-zA-Z0-9_\-]{18})(?:&.*)*&v=([a-zA-Z0-9_\-]{11})))(?:&.*)*(?:\#.*)*$/

		let matchPlaylist = url.match(youtubePlaylist)
		let match = url.match(youtubeRegex)
		let matchMobile = url.match(youtubeMobile)

		if (matchPlaylist) {
			let http = matchPlaylist[1]
			let id = matchPlaylist[3]
			let listID = matchPlaylist[4]

			return http + '//www.youtube.com/embed/' + id + '?' + 'list=' + listID + '?enablejsapi=1'
		}
		else if (match) {
			let http = match[1]
			let id = match[6]

			return http + '//www.youtube.com/embed/' + id + '?enablejsapi=1'
		}
		else if (matchMobile) {
			let http = matchMobile[1]
			let id = matchMobile[6]

			return http + '//www.youtube.com/embed/' + id + '?enablejsapi=1'
		}

		return ''
	}
}

export default Embed
